// src/mathjax.js
// MathJax (~250 KB) chỉ tải ở các trang có công thức (khoá học, chuyên đề, đề luyện thi, trắc nghiệm, quản trị),
// không tải ở trang chủ, giới thiệu... Tải xong MathJax tự hiện công thức đang có trên trang; các chỗ vẽ thêm
// nội dung sau đó vẫn gọi window.MathJax.typesetPromise như cũ.
const MATHJAX_URL = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js";

let loading = null;

export const loadMathJax = () => {
  if (loading) return loading;
  loading = new Promise((resolve) => {
    if (!window.MathJax) {
      window.MathJax = {
        tex: { inlineMath: [["$", "$"], ["\\(", "\\)"]] },
        startup: {
          pageReady: () => window.MathJax.startup.defaultPageReady().then(resolve),
        },
      };
    }
    const script = document.createElement("script");
    script.id = "MathJax-script";
    script.async = true;
    script.src = MATHJAX_URL;
    script.onerror = () => {
      loading = null; // lỗi mạng: lần sau thử lại
      resolve();
    };
    document.head.appendChild(script);
  });
  return loading;
};

// Các trang cần công thức toán
export const needsMathJax = (pathname) => /^\/(course|topic|practice|quiz|admin)(\/|$)/.test(pathname);
